import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Questions from './pages/Questions';
import StarterQuestionnaire from './pages/StarterQuestionnaire';
import Survey from './pages/Survey';
import OnboardingForm from './pages/OnboardingForm';

function App() {
  return (
    <Router>
      {/* <nav style={{ padding: '10px', background: '#eee' }}>
        <Link to="/" style={{ marginRight: '20px' }}>Home</Link>
        <Link to="/questions">Questions</Link>
      </nav> */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/staff-onboarding" element={<Questions />} />
        <Route path="/health-questionnaire" element={<StarterQuestionnaire />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/onboarding/:token" element={<OnboardingForm />} />
      </Routes>
    </Router>
  );
}

export default App;
